import { render, staticRenderFns } from "./divideAccounts.vue?vue&type=template&id=6ca1ea34&scoped=true"
import script from "./divideAccounts.vue?vue&type=script&lang=js"
export * from "./divideAccounts.vue?vue&type=script&lang=js"
import style0 from "./divideAccounts.vue?vue&type=style&index=0&id=6ca1ea34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1ea34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca1ea34')) {
      api.createRecord('6ca1ea34', component.options)
    } else {
      api.reload('6ca1ea34', component.options)
    }
    module.hot.accept("./divideAccounts.vue?vue&type=template&id=6ca1ea34&scoped=true", function () {
      api.rerender('6ca1ea34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/product/components/divideAccounts.vue"
export default component.exports